import React from 'react';
import { getDeviceName } from "../../../../../../Utils";

const Row = ({ country, device, spends, conversions, eCost }) => {
    return (
        <tr>
            <td>{country}</td>
            <td>{getDeviceName(device)}</td>
            <td>{spends}</td>
            <td>{conversions}</td>
            <td>{eCost}</td>
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/BidderECostCountry/components/PeriodTable/components/Row/index.js